import { NavigationTab } from 'shared/model';

export const TABS: Array<NavigationTab> = [
  {
    key: 'edit-role',
    label: 'Редактирование роли',
    path: '',
  },
  {
    key: 'controller-claims',
    label: 'Права',
    path: `controller-claims`,
  },
  {
    key: 'charge-point-rights',
    label: 'ЭЗС',
    path: `charge-point-rights`,
  },
  {
    key: 'users',
    label: 'Пользователи',
    path: `users`,
  },
];
